import { render } from "./ParentsRecord.vue?vue&type=template&id=6c6af1fc&ts=true"
import script from "./ParentsRecord.vue?vue&type=script&lang=ts"
export * from "./ParentsRecord.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__